import React                     from 'react';
import { boardWidth as tooltip } from 'pu-data/Tooltips';
import TextComponent             from './base/TextComponent';

const BoardWidth = (props) => {
  const name = 'board_width';
  const onChange = e => props.onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      label={props.label}
      name={name}
      inputId={props.inputId}
      value={props.parameters[name] || ''}
      required={props.required}
      placeholder={props.placeholder}
      groupName={props.groupName}
      onChange={props.onChange || onChange}
      tooltip={props.tooltip}
      className={props.className}
      inputClassName={props.inputClassName} 
      error={props.error} />
  );
};

BoardWidth.defaultProps = {
  label      : 'Board Width',
  placeholder: 'width',
  tooltip,
};

export default BoardWidth;
